import { OpenInNew } from '@mui/icons-material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { LoadingButton } from '@mui/lab';
import { Button, Collapse, Divider, Stack, Typography } from '@mui/material';
import { SubscriptionStatus, User } from '../../database/user';
import { RequestSnackbar, useRequest } from '../../api/Request';
import { useApi } from '../../api/Api';
import SubscriptionPriceMatrix from '../../subscription/SubscriptionPriceMatrix';
import { useState } from 'react';

interface SubscriptionManagerProps {
    user: User;
}

const SubscriptionManager: React.FC<SubscriptionManagerProps> = ({ user }) => {
    const request = useRequest();
    const api = useApi();
    const [showPricing, setShowPricing] = useState(false);

    const onManageSubscription = () => {
        request.onStart();
        api.subscriptionManage()
            .then((resp) => {
                window.location.href = resp.data.url;
            })
            .catch((err) => {
                console.error('subscriptionManage: ', err);
                request.onFailure(err);
            });
    };

    const isSubscribed = user.subscriptionStatus === SubscriptionStatus.SUBSCRIBED;

    const renderSubscriptionContent = () => {
        if (user.isArtist) {
            return (
                <Typography>
                    You are automatically granted access and do not need to subscribe.
                </Typography>
            );
        }

        if (user.subscriptionOverride) {
            return (
                <Typography>
                    You have been gifted a subscription and are currently subscribed!
                </Typography>
            );
        }

        if (isSubscribed) {
            return (
                <>
                    <Typography>Subscription Status: Subscribed</Typography>
                    <LoadingButton
                        loading={request.isLoading()}
                        onClick={onManageSubscription}
                        variant='contained'
                        endIcon={<OpenInNew />}
                    >
                        Manage Subscription
                    </LoadingButton>
                </>
            );
        }

        return (
            <>
                <Typography>You do not have a subscription</Typography>
                <Button variant='outlined' onClick={() => setShowPricing(!showPricing)}>
                    {showPricing
                        ? 'Hide Subscription Options'
                        : 'View Subscription Options'}
                </Button>

                <Collapse in={showPricing} sx={{ width: '100%' }}>
                    <SubscriptionPriceMatrix user={user} redirectPath='/profile' />
                </Collapse>
            </>
        );
    };

    return (
        <Stack spacing={2} alignItems='start'>
            <RequestSnackbar request={request} />

            <Stack
                id='subscription'
                width={1}
                sx={{
                    scrollMarginTop: 'calc(var(--navbar-height) + 8px)',
                }}
            >
                <Typography variant='h5'>
                    <MonetizationOnIcon
                        sx={{ verticalAlign: 'middle', marginRight: '0.1em' }}
                    />{' '}
                    Subscription Status
                </Typography>
                <Divider />
            </Stack>

            {renderSubscriptionContent()}
        </Stack>
    );
};

export default SubscriptionManager;
